export default __webpack_public_path__ + "static/registerModalBg-c4fc9cc6261548e21a141117bc151531.png";